import React from 'react';
import { Form as AntdForm, Input } from 'antd';
import { connect } from 'react-redux';
import PopoutForm from '../forms/PopoutForm';

const { Item } = AntdForm;

const Form = ({
  form, defaultValues, error, onSubmit, user,
}) => (
  <PopoutForm
    layout="vertical"
    form={form}
    popoutError={error}
    onFinish={onSubmit}
    initialValues={defaultValues}
  >
    <Item
      key="name"
      name="name"
      label="Name"
      rules={[{ required: true, message: 'Name is required' }]}
    >
      <Input
        size="large"
        placeholder="Name"
      />
    </Item>
    <Item
      key="keywords"
      name="keywords"
      label="Keywords"
      rules={[{ required: true, message: 'Keywords are required' }]}
    >
      <Input.TextArea
        size="large"
        placeholder="Keywords or phrases, one per line"
      />
    </Item>
    <Item
      key="prompt"
      name="prompt"
      label="Prompt"
      rules={[{ required: true, message: 'Prompt is required' }]}
      style={{ visibility: user.email.endsWith('@clientzen.io') ? 'visible' : 'hidden' }}
    >
      <Input.TextArea
        size="large"
        placeholder="The prompt"
      />
    </Item>
  </PopoutForm>
);

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, null)(Form);
